import { IBasicAutomation, IUpdateBasicAutomationTrigger } from 'modules/settings/models';
import API from 'services/api';

export const updateBasicAutomationTrigger = ({
  triggerKey,
  payload,
}: {
  triggerKey: string;
  payload: IUpdateBasicAutomationTrigger;
}): Promise<IBasicAutomation> => {
  return API.patch(`/api/basic-automation/triggers/${triggerKey}`, payload);
};
